






























































































































































































































































































































































































































































import { Component, Vue, Watch, Mixins, Prop } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PartnerApi from '@/api/partner'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import { filterColumnsByPermission } from '@/utils/helper/permission'

@Component({
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = filterColumnsByPermission(columns)
	private data: any[] = []
	private visible: boolean = false
	private dispatchVisible: boolean = false
	private dispatchData: any = []
	private dispatchColumns: any = [
		{
			title: '序号',
			dataIndex: 'order',
			align: 'center',
			width: 60,
			scopedSlots: { customRender: 'order' },
		},
		{
			title: '资源公司',
			align: 'center',
			dataIndex: 'partnerName',
		},
		{
			title: '作业人员',
			align: 'center',
			dataIndex: 'visitorName',
		},
		{
			title: '响应时间',
			align: 'center',
			dataIndex: 'beginOperateTime',
			scopedSlots: { customRender: 'beginOperateTime' },
		},
		{
			title: '调度次数',
			align: 'center',
			dataIndex: 'dispatchNumber',
		},
		{
			title: '延时',
			align: 'center',
			dataIndex: 'postoneFlag',
			scopedSlots: { customRender: 'postoneFlag' },
		},
		{
			title: '退回',
			align: 'center',
			dataIndex: 'auditFailedFlag',
			scopedSlots: { customRender: 'auditFailedFlag' },
		},
		{
			title: '撤单',
			align: 'center',
			dataIndex: 'cancel',
			scopedSlots: { customRender: 'cancel' },
		},
		{
			title: '发起方',
			align: 'center',
			dataIndex: 'cancelType',
			scopedSlots: { customRender: 'cancelType' },
		},
	]

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	@Prop()
	private visitorId!: any

	@Watch('visitorId', { immediate: true })
	private onVisitorChange() {
		if (this.visitorId) {
			this.$nextTick(() => {
				this.getList()
			})
		}
	}

	public getList() {
		const form = this.getForm()
		if (this.inVisitorDetail) {
			form.visitorId = this.visitorId
		}
		return PartnerApi.getOrderList(form).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	private get inVisitorDetail() {
		return !!this.visitorId
	}

	private lt12h(str: any) {
		const m = str.includes('min')
		if (!m) {
			return false
		}
		const s = str.split('h')
		if (s.length > 1) {
			return +s[0] < 12
		}
		return true
	}

	private setRowClass(row: any) {
		if (this.lt12h(row.endEffectTimeStr)) {
			return 'red'
		}
	}

	public activated() {
		this.$store.dispatch('setting/initPartnerTree')
		this.$store.dispatch('setting/initAreas')
		this.getList()
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.beginTime =
			form.startendTime &&
			form.startendTime[0] &&
			form.startendTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.startendTime &&
			form.startendTime[1] &&
			form.startendTime[1].format('YYYY-MM-DD')
		delete form.startendTime

		return form
	}

	private async getDispatch(row: any) {
		const res = await PartnerApi.getDispatchList(row.orderId)
		this.dispatchData = res.data
		this.dispatchVisible = true
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	private exportList() {
		this.exportingList = true
		PartnerApi.exportOrderList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
	private goWorkDetail(row: any) {
		// this.$router.push({
		// 	name: `partnerWorkDetail`,
		// 	params: {
		// 		orderId: row.orderId,
		// 		dispatchId: row.dispatchId,
		// 	},
		// })
		TaskApi.operation({ orderId: row.orderId })
			.then((res: any) => {
				this.$router.push({
					name: `partnerWorkDetail`,
					params: {
						orderId: row.orderId,
						dispatchId: row.dispatchId,
					},
				})
			})
			.finally(() => {
				console.log('')
			})
	}
}
